import { Gender } from './eums/gender';
import { ResidenceModel } from './residenceModel';
import { PersonIdentityModel } from './personIdentityModel';
import { RolesModel } from './rolesModel';
import { ComsModels } from './comsModel';
import { SocialMediaModel } from './socialMediaModel';
import { PhoneType } from './eums/phoneType';
import { EmailType } from './eums/emailType';
import { CertificationModel } from './certificationModel';

export class PersonModel {
  personUUID?: PersonIdentityModel;
  passportGivenName?: string;
  passportFamilyName?: string;
  preferredGivenName?: string;
  preferredFamilyName?: string;
  nickname?: string;
  birthDate?: Date;
  genderCode?: Gender;
  nationalityCode?: string;
  residence?: ResidenceModel;
  certifications?: CertificationModel[];
  roles?: RolesModel[];
  coms: ComsModels = {
    phoneNumbers: [{ phoneType: PhoneType.Mobile, phoneNumber: '' }],
    emailAddresses: [{ emailType: EmailType.Primary, emailAddress: '' }],
  };
  socialMediaHandles?: SocialMediaModel;
  avatarUrl?: string;
}
